/* eslint-disable */

import React, { Component } from 'react';
import { Button, Form, Divider, Grid, Dropdown } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, graphql, withApollo } from 'react-apollo';
import * as AppActions from '../../actions';
import _ from 'lodash';

import { getVideo } from '../../fbApi/Videos';
import PreviewList from '../Canvas/PreviewList';
import CarouselPreviewList from './CarouselPreviewList';
import * as AdBlueprintDB from '../../database/AdBlueprintDB';
import './AdBlueprintBuilder.css';

class AdBlueprintBuilder extends Component {
  state = {
    token: this.props.getFbToken(),
    pages: this.props.pages,
    canvases: [],
    carousels: this.props.carousels,
    cards: [],
    carouselsOptions: this.props.carouselsOptions,
    accountOptions: this.props.accounts,
    message: '',
    errorMessage: '',
    canvasElements: [],
    assetPreview: '',
    adTypes: [],
    tiles: [],
    form: {
      adName: '',
      adAccount: '',
      pageId: '',
      adType: '',
      canvas: 0,
      carousel: 0,
      headline: '',
      copy: '',
      asset: '',
      linkDescription: '',
      displayLink: '',
      imageUrl: '',
      tile: '',
      variables: []
    }
  };

  componentDidMount() {
    this.fillAdTypes();
  }

  initializeEdit = async (adBlueprintToEdit) => {
    await this.getVideoUrl(adBlueprintToEdit.asset);
    if (adBlueprintToEdit.canvasId && adBlueprintToEdit.canvasId !== 0) {
      this.onCanvasSelect(null, { value: adBlueprintToEdit.canvasId });
    }

    let form = this.state.form;
    form.adName = adBlueprintToEdit.name;
    form.adAccount = adBlueprintToEdit.adAccount;
    form.pageId = adBlueprintToEdit.page;
    form.adType = adBlueprintToEdit.adType;
    form.canvas = adBlueprintToEdit.canvasId;
    form.carousel = adBlueprintToEdit.carouselId;
    form.headline = adBlueprintToEdit.headline;
    form.copy = adBlueprintToEdit.adCopy;
    form.asset = adBlueprintToEdit.asset;
    form.linkDescription = adBlueprintToEdit.linkDescription;
    form.imageUrl = adBlueprintToEdit.imageUrl;

    if (adBlueprintToEdit.canvasId && adBlueprintToEdit.canvasId !== 0) {
      const tile = this.props.data.canvasTile.list.find(
        (tile) =>
          tile.asset === adBlueprintToEdit.asset &&
          tile.imageUrl === adBlueprintToEdit.imageUrl &&
          tile.canvasId === adBlueprintToEdit.canvasId
      );

      if (tile) {
        form.tile = tile.id;
      }
    }

    let variables = [];
    const urlValues = JSON.parse(adBlueprintToEdit.urlValues);
    urlValues.urlValues.map((urlVariable) => {
      variables.push({ name: urlVariable.name, value: urlVariable.value });
    });

    form.variables = variables;

    this.setState({ form });

    if (adBlueprintToEdit.carouselId && adBlueprintToEdit.carouselId !== 0) {
      const carousel = this.state.carousels.find(
        (item) => item.id === adBlueprintToEdit.carouselId
      );
      this.setState({ cards: carousel.cards });
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data.canvases && nextProps.data.canvases.list) {
      this.fillCanvases(nextProps.data.canvases.list);
      if (this.props.adBlueprintToEdit) {
        this.initializeEdit(this.props.adBlueprintToEdit);
      }
    }
  };

  clearFields = () => {
    const form = {
      adName: '',
      adAccount: '',
      pageId: '',
      adType: '',
      canvas: 0,
      carousel: 0,
      headline: '',
      copy: '',
      asset: '',
      linkDescription: '',
      displayLink: '',
      imageUrl: '',
      variables: []
    };

    this.setState({ form });
  };

  fillAdTypes = async () => {
    const adTypes = [
      'Canvas',
      'Carousel',
      'Collection',
      'Still',
      'Video',
      'Cinemagraph'
    ];
    const adTypesOptions = _.sortBy(
      _.map(adTypes, (op, index) => ({
        key: index,
        value: op,
        text: op
      })),
      'text'
    );
    this.setState({ adTypes: adTypesOptions });
  };

  fillCanvases = async (canvases) => {
    const canvasOptions = _.sortBy(
      _.map(canvases, (op, index) => ({
        key: index,
        value: op.id,
        text: op.name
      })),
      'text'
    );

    this.setState({ canvases: canvasOptions });
  };

  onAccountSelect = async (event, data) => {
    const account = _.find(data.options, (option) => {
      return option.value === data.value;
    });
    const accountId = account.value;
    const form = this.state.form;
    form.adAccount = accountId;

    this.setState({ form });
  };

  onPageSelect = (event, data) => {
    let selectedPage = _.find(data.options, (opt) => {
      return opt.value === data.value;
    });

    const form = this.state.form;

    if (selectedPage) {
      form.pageId = selectedPage.value;
    }

    this.setState({ form });
  };

  onAdTypeSelect = (event, data) => {
    let selectedAdType = _.find(data.options, (opt) => {
      return opt.value === data.value;
    });

    const form = this.state.form;

    form.canvas = 0;
    form.carousel = 0;
    form.variables = [];
    form.imageUrl = '';

    if (selectedAdType) {
      form.adType = selectedAdType.value;
    }

    this.setState({ form, cards: [], assetPreview: '', tiles: [] });
  };

  onTileSelect = async (event, data) => {
    this.setState({ assetPreview: '' });
    const tile = this.props.data.canvasTile.list.find(
      (tile) => tile.id === data.value
    );
    const form = this.state.form;
    form.asset = '';
    form.image_url = '';
    form.tile = '';

    if (tile) {
      form.asset = tile.asset;
      form.imageUrl = tile.imageUrl;
      form.tile = data.value;

      if (tile.asset) {
        await this.getVideoUrl(tile.asset);
      }
    }

    this.setState({ form });
  };

  fillTiles = async (tiles) => {
    const tilesOptions = _.sortBy(
      _.map(tiles, (op, index) => ({
        key: index,
        value: op.id,
        text: op.name
      })),
      'text'
    );

    this.setState({ tiles: tilesOptions });
  };

  onCarouselSelect = (event, data) => {
    let variables = [];
    const carousel = this.state.carousels.find(
      (item) => item.id === data.value
    );
    const form = this.state.form;
    form.carousel = data.value;
    let body = carousel.body;

    while (body.indexOf('<') !== -1 && body.indexOf('>') !== -1) {
      const variable = body.substring(body.indexOf('<'), body.indexOf('>') + 1);
      const existVariable = variables.find(
        (urlVariable) => urlVariable.name === variable
      );
      if (!existVariable) {
        variables.push({ name: variable, value: '' });
      }
      body = body.replace(variable, '');
    }

    carousel.cards.map(async (card) => {
      let link = card.link;
      while (link.indexOf('<') !== -1 && link.indexOf('>') !== -1) {
        const variable = link.substring(
          link.indexOf('<'),
          link.indexOf('>') + 1
        );
        const existVariable = variables.find(
          (urlVariable) => urlVariable.name === variable
        );
        if (!existVariable) {
          variables.push({ name: variable, value: '' });
        }
        link = link.replace(variable, '');
      }
    });

    form.variables = variables;

    this.setState({ form, cards: carousel.cards });
  };

  onCanvasSelect = (event, data) => {
    let variables = [];

    const form = this.state.form;
    let canvasElements = [];

    if (this.props.data && data.value) {
      form.canvas = data.value;

      const canvas = this.props.data.canvases
        ? this.props.data.canvases.list.filter((canvas) => {
            return canvas.id === data.value;
          })
        : [];
      const tiles = this.props.data.canvasTile
        ? this.props.data.canvasTile.list.filter((tile) => {
            return tile.canvasId === data.value;
          })
        : [];
      this.fillTiles(tiles);

      if (canvas) {
        form.headline = canvas[0].headline;
        form.copy = canvas[0].copy;
      }

      const photos = this.props.data.canvasPhoto
        ? this.props.data.canvasPhoto.list.filter((photo) => {
            return photo.canvasId === data.value;
          })
        : [];
      const carousels = this.props.data.canvasCarousel
        ? this.props.data.canvasCarousel.list.filter((carousel) => {
            return carousel.canvasId === data.value;
          })
        : [];
      const videos = this.props.data.canvasVideo
        ? this.props.data.canvasVideo.list.filter((video) => {
            return video.canvasId === data.value;
          })
        : [];

      photos.map((photo) => {
        if (
          photo.targetUrl.indexOf('<') !== -1 &&
          photo.targetUrl.indexOf('>') !== -1
        ) {
          variables.push({ name: photo.targetUrl, value: '' });
        }
        canvasElements.push({
          type: 'Photo',
          url: photo.imageUrl,
          order: photo.order
        });
      });

      videos.map((video) => {
        canvasElements.push({
          type: 'Video',
          url: video.videoUrl,
          order: video.order
        });
      });

      carousels.map((carousel) => {
        let cards = [];
        this.props.data.canvasCarouselCard.list.map((item) => {
          if (
            carousel.id === item.carouselId &&
            item.targetUrl.indexOf('<') !== -1 &&
            item.targetUrl.indexOf('>') !== -1
          ) {
            variables.push({ name: item.targetUrl, value: '' });
          }
          cards.push({ cardImageUrl: item.imageUrl });
        });
        canvasElements.push({ type: 'Carousel', cards, order: carousel.order });
      });

      form.variables = variables;
    }

    this.setState({ form, canvasElements });
  };

  goBackSearch = () => {
    this.props.searchPage();
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleVariableChange = (event, { name, value }) => {
    let form = this.state.form;
    form.variables.map((variable) => {
      if (variable.name === name) {
        variable.value = value;
      }
    });

    this.setState({ form });
  };

  renderUrlFields = () => {
    const variables = this.state.form.variables;

    if (this.state.form.adType === 'Canvas') {
      let headline = this.state.form.headline;
      let copy = this.state.form.copy;

      while (headline.indexOf('<') !== -1 && headline.indexOf('>') !== -1) {
        const variable = headline.substring(
          headline.indexOf('<'),
          headline.indexOf('>') + 1
        );
        const existVariable = variables.find(
          (urlVariable) => urlVariable.name === variable
        );
        if (!existVariable) {
          variables.push({ name: variable, value: '' });
        }
        headline = headline.replace(variable, '');
      }

      while (copy.indexOf('<') !== -1 && copy.indexOf('>') !== -1) {
        const variable = copy.substring(
          copy.indexOf('<'),
          copy.indexOf('>') + 1
        );
        const existVariable = variables.find(
          (urlVariable) => urlVariable.name === variable
        );
        if (!existVariable) {
          variables.push({ name: variable, value: '' });
        }
        copy = copy.replace(variable, '');
      }
    }

    return variables.map((url) => {
      return (
        <div>
          <Divider hidden />
          <label>
            <b>* Variable</b>
          </label>
          <Form.Input
            className="input-text-blueprint"
            placeholder={url.name}
            type="text"
            name={url.name}
            value={url.value}
            onChange={this.handleVariableChange}
          />
        </div>
      );
    });
  };

  validFields = () => {
    const form = this.state.form;
    let valid = form.adName && form.adAccount && form.pageId && form.adType;

    if (form.adType === 'Canvas') {
      valid = valid && form.canvas && form.asset && form.imageUrl;
    }

    if (form.adType === 'Carousel') {
      valid = valid && form.carousel;
    }

    form.variables.map((variable) => {
      if (!variable.value) {
        valid = false;
      }
    });

    return valid;
  };

  saveBlueprint = async () => {
    this.setState({ message: '', errorMessage: '' });

    if (!this.validFields()) {
      this.setState({ errorMessage: 'The fields marked with * are mandatory' });
      return;
    }

    const user = this.props.user;
    const form = this.state.form;

    const adBlueprint = {
      name: form.adName,
      adAccount: form.adAccount,
      page: form.pageId,
      adType: form.adType,
      canvasId: form.canvas,
      carouselId: form.carousel,
      urlValues: JSON.stringify({ urlValues: form.variables }),
      headline: form.headline,
      adCopy: form.copy,
      asset: form.asset,
      linkDescription: form.linkDescription,
      displayLink: form.displayLink,
      imageUrl: form.imageUrl,
      createdAt: new Date(),
      createdBy: user.email,
      updatedAt: new Date(),
      updatedBy: user.email
    };

    try {
      if (this.props.adBlueprintToEdit) {
        adBlueprint.id = this.props.adBlueprintToEdit.id;
      }

      const result = this.props.adBlueprintToEdit
        ? await this.props.updateAdBlueprint(adBlueprint)
        : await this.props.saveAdBlueprint(adBlueprint);
      const message = this.props.adBlueprintToEdit
        ? 'The Ad Blueprint has been edited'
        : 'The Ad Blueprint has been created';
      const newAdBlueprint = result.data;

      if (!newAdBlueprint) {
        this.setState({
          errorMessage: 'ERROR Ad Blueprint failed to be saved.'
        });
        return;
      }

      this.setState({ message });
      if (!this.props.adBlueprintToEdit) {
        this.clearFields();
      }
    } catch (error) {
      this.setState({ errorMessage: 'ERROR Ad Blueprint failed to be saved.' });
    }

    setTimeout(() => {
      this.setState({ message: '', errorMessage: '' });
    }, 5000);
  };

  getVideoUrl = async (asset) => {
    const video = await getVideo(asset, this.state.token);
    const assetPreview = video && video.source ? video.source : '';
    this.setState({ assetPreview });
  };

  render() {
    const {
      adName,
      headline,
      copy,
      asset,
      pageId,
      adAccount,
      adType,
      canvas,
      imageUrl,
      tile,
      carousel
    } = this.state.form;
    const cols = this.state.form.adType === 'Canvas' ? 5 : 3;
    return (
      <div>
        <Form>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column>
                <div className="back-link">
                  <Button onClick={this.goBackSearch} size="small" color="blue">
                    Back
                  </Button>
                  <Button
                    onClick={this.saveBlueprint}
                    size="small"
                    color="blue"
                  >
                    Save
                  </Button>
                  {this.state.message ? (
                    <div className="message-container">
                      <span>{this.state.message}</span>
                    </div>
                  ) : null}
                  {this.state.errorMessage ? (
                    <div className="error-message-container">
                      <span>{this.state.errorMessage}</span>
                    </div>
                  ) : null}
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={cols}>
              <Grid.Column>
                <label>
                  <b>* Ad Name</b>
                </label>
                <Form.Input
                  className="input-text-blueprint"
                  placeholder="Ad Name"
                  type="text"
                  name="adName"
                  value={adName}
                  onChange={this.handleFormChange}
                />
                <Divider hidden />
                <label>
                  <b>* Ad Accounts</b>
                  <br />
                </label>
                <Dropdown
                  label="* Ad Accounts"
                  placeholder="Ad Accounts"
                  search
                  selection
                  value={adAccount}
                  options={this.state.accountOptions}
                  onChange={this.onAccountSelect}
                />
                <Divider hidden />
                <label>
                  <b>* Pages</b>
                  <br />
                </label>
                <Dropdown
                  placeholder="Pages"
                  search
                  selection
                  value={pageId}
                  options={this.state.pages}
                  onChange={this.onPageSelect}
                />
                <Divider hidden />
                <label>
                  <b>* Ad Types</b>
                  <br />
                </label>
                <Dropdown
                  placeholder="Ad Types"
                  search
                  selection
                  value={adType}
                  options={this.state.adTypes}
                  onChange={this.onAdTypeSelect}
                />
              </Grid.Column>
              <Grid.Column>
                {this.state.form.adType === 'Canvas' ? (
                  <div>
                    <label>
                      <b>* Canvas</b>
                      <br />
                    </label>
                    <Dropdown
                      placeholder="Canvas"
                      search
                      selection
                      value={canvas}
                      options={this.state.canvases}
                      onChange={this.onCanvasSelect}
                    />
                  </div>
                ) : null}
                {this.state.form.adType === 'Carousel' ? (
                  <div>
                    <label>
                      <b>* Carousel</b>
                      <br />
                    </label>
                    <Dropdown
                      placeholder="Carousel"
                      search
                      selection
                      value={carousel}
                      options={this.state.carouselsOptions}
                      onChange={this.onCarouselSelect}
                    />
                  </div>
                ) : null}
                {this.renderUrlFields()}
              </Grid.Column>
              <Grid.Column>
                {this.state.form.adType === 'Canvas' ? (
                  <div>
                    <label>
                      <b>Headline</b>
                    </label>
                    <Form.Input
                      className="input-text-blueprint"
                      placeholder="Headline"
                      type="text"
                      disabled
                      name="headline"
                      value={headline}
                      onChange={this.handleFormChange}
                    />
                    <Divider hidden />
                    <label>
                      <b>Copy</b>
                    </label>
                    <Form.Input
                      className="input-text-blueprint"
                      placeholder="Copy"
                      type="text"
                      disabled
                      name="copy"
                      value={copy}
                      onChange={this.handleFormChange}
                    />
                    <Divider hidden />
                    <label>
                      <b>* Marketing Tile</b>
                      <br />
                    </label>
                    <Dropdown
                      label="* Tiles"
                      placeholder="Tiles"
                      search
                      selection
                      value={tile}
                      options={this.state.tiles}
                      onChange={this.onTileSelect}
                    />
                  </div>
                ) : null}
                {this.state.form.adType === 'Carousel' ? (
                  <CarouselPreviewList
                    cards={this.state.cards}
                    getFbToken={this.props.getFbToken}
                  />
                ) : null}
              </Grid.Column>
              <Grid.Column>
                {this.state.form.adType === 'Canvas' ? (
                  <div>
                    <div>
                      <div className="image-preview-blueprint-container">
                        <label>
                          <b>Asset Preview</b>
                        </label>
                        {this.state.assetPreview ? (
                          <video width="100%" controls loop autoPlay>
                            <source
                              src={this.state.assetPreview}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <div className="image-preview-container"></div>
                        )}
                      </div>
                    </div>
                    <Divider hidden />
                    <div>
                      <div className="image-preview-blueprint-container">
                        <label>
                          <b>Image Url Preview</b>
                        </label>
                        <div className="image-preview-container">
                          <img
                            className="image-preview-blueprint"
                            src={imageUrl}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </Grid.Column>
              <Grid.Column>
                {this.state.form.adType === 'Canvas' ? (
                  <div>
                    <label>
                      <b>Canvas Preview</b>
                    </label>
                    {this.state.form.canvas ? (
                      <PreviewList
                        canvasElements={this.state.canvasElements}
                        showOnlyAssets
                      />
                    ) : null}
                  </div>
                ) : null}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const withAdBlueprintBuilder = compose(
  graphql(AdBlueprintDB.getAllCanvases),
  graphql(AdBlueprintDB.submitAdBlueprint, {
    props: ({ mutate }) => ({
      saveAdBlueprint: (adBlueprint) => mutate({ variables: { adBlueprint } })
    })
  }),
  graphql(AdBlueprintDB.updateAdBlueprint, {
    props: ({ mutate }) => ({
      updateAdBlueprint: (adBlueprint) =>
        mutate({
          variables: {
            id: adBlueprint.id,
            adBlueprint: _.omit(adBlueprint, [
              'id',
              'createdAt',
              'createdBy',
              '__typename'
            ])
          }
        })
    })
  })
);

const ListWithData = withAdBlueprintBuilder(AdBlueprintBuilder);

export default withApollo(
  connect(mapStateToProps, mapDispatchToProps)(ListWithData)
);



// WEBPACK FOOTER //
// ./src/screens/AdBlueprint/AdBlueprintBuilder.js